import React, { Component } from "react";
import PropTypes from "prop-types";
import { Tooltip, Popover, PopoverBody } from "reactstrap";
import PitchSlide from "./pitch_slide";
import MessageContent from "./message_content";

class ReceivedMessage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isTooltipShow: false,
      isPopoverShow: false
    };
  }

  handleTooltipShow = () => {
    this.setState(prevState => (
      { isTooltipShow: !prevState.isTooltipShow }
    ));
  };

  handlePopoverShow = () => {
    this.setState(prevState => (
      { isPopoverShow: !prevState.isPopoverShow }
    ));
  };

  renderPitchNoticeMessage = () => {
    return (
      <p className='pitch-notice'>
        <i className='far fa-envelope text-primary' />
        &nbsp;新しいメッセージが届きました
        <br />
        この起業家に興味があればご返信をお願いします
      </p>
    );
  };

  render () {
    const { isTooltipShow, isPopoverShow } = this.state;
    const { message } = this.props;

    return (
      <React.Fragment>
        { message.pitch && (
          <div className='overflowreset'>
            {this.renderPitchNoticeMessage()}
            <PitchSlide pitch={message.pitch} />
          </div>
        )}
        <div className='incoming-msg message-unit'>
          <div id={`sender-image-icon-${message.id}`} className='incoming-msg-img' onClick={this.handlePopoverShow} role='presentation'>
            <img src={message.user_image} alt={message.user_name} className='rounded-circle' />
          </div>
          <div className='received-msg'>
            <div className='received-withd-msg'>
              <MessageContent
                content={message.content}
                created_at={message.created_at}
              />
            </div>
          </div>
        </div>

        <Tooltip placement='left' isOpen={isTooltipShow} target={`sender-image-icon-${message.id}`} toggle={this.handleTooltipShow}>
          {message.user_full_name}
        </Tooltip>
        <Popover placement='bottom' isOpen={isPopoverShow} target={`sender-image-icon-${message.id}`} toggle={this.handlePopoverShow}>
          <PopoverBody>
            <a href={`/${message.user_name}`} data-turbolinks='false' target='_blank' rel='noopener noreferrer'>
              プロフィールを見る
            </a>
          </PopoverBody>
        </Popover>
      </React.Fragment>
    );
  }
}

ReceivedMessage.propTypes = {
  message: PropTypes.shape({
    user_image: PropTypes.string.isRequired,
    user_name: PropTypes.string.isRequired,
    user_full_name: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    pitch: PropTypes.object
  }).isRequired
};

export default ReceivedMessage;
